<template>
  <transition name="fade">
    <div class="modal" v-show="visible">
      <div class="modal__wrap">
        <div class="modal__body">
          <a href="#" class="modal__close" @click.prevent="hide">x</a>
          <page-register-form
                  submit-button-text="เข้าสู่ระบบ"
                  :back-button="false"
                  @submit="success"
                  ref="form" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

  import Loader from './Loader.vue'
  import PageRegisterForm from './PageRegisterForm'

  export default {
    name: 'LoginModal',

    components: {
      Loader,
      PageRegisterForm
    },

    data () {
      return {
        visible: false
      }
    },

    methods: {
      show () {
        this.visible = true
      },

      hide () {
        this.visible = false
      },

      success () {
        this.hide()
        if (this.$route.query.next) {
          this.$router.push(this.$route.query.next)
        } else {
          this.$router.push(`/${process.env.MAIN_PRODUCT_SKU}`)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .modal {
    z-index: 99;
    &__title {
      font-size: 1.3em
    }

    .modal__close {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 24px;
      padding: 3px 10px;
    }

    /deep/ .button-actions {
      text-align: center;
    }

    /deep/ .btn-submit-button {
      float: left;
    }
  }
</style>



// WEBPACK FOOTER //
// LoginModal.vue?1c45846e